import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";

const firebaseConfigDevelopment = {
  apiKey: "AIzaSyALpJytKlQ8jKFJ1-Fa5KX8xB0vrUTUoSo",
  authDomain: "mobile-track-trucking-develop.firebaseapp.com",
  projectId: "mobile-track-trucking-develop",
  storageBucket: "mobile-track-trucking-develop.appspot.com",
  messagingSenderId: "356687652094",
  appId: "1:356687652094:web:873b3cb7aab261630d71af"
};

const firebaseConfigProduction = {
  apiKey: "AIzaSyBRyC3Q8xMjpeXg722dbsfQEMPthXs1pss",
  authDomain: "mobile-track-trucking.firebaseapp.com",
  projectId: "mobile-track-trucking",
  storageBucket: "mobile-track-trucking.appspot.com",
  messagingSenderId: "1013355769811",
  appId: "1:1013355769811:web:481397c0f27625459a4926",
  measurementId: "G-V1M42GKK8F"
};

firebase.initializeApp(
  process.env.REACT_APP_FIREBASE_ENV === "development"
    ? firebaseConfigDevelopment
    : firebaseConfigProduction
);

// firebase.firestore().enablePersistence().catch((err) => {
// 	console.log(err.code)
// });

export default firebase;
